import Button from "@components/common/Button.component";
import { useState, useEffect } from "react";
import { data } from "./data";
import TimelineItem from "./TimelineItem.component";

const Timeline = () => {
  const [height, setheight] = useState(`showLess`);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }
  const [windowSize, setWindowSize] = useState(getWindowSize());
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return (
    <>
      <div className={`timeline-div ${height}`}>
        <h4 className="timeline-text">GangstaVerse,</h4>
        <h4 className="timeline-text">thus far</h4>
        {/* <p className="timeline-text-details">
          Here are some of the milestones of the project.
        </p> */}
        {/* <div className="timeline-content">
          {data.map((item: any, index: any) => {
            return <TimelineItem data={item} key={index} />;
          })}
        </div> */}
        <section className="timeline-section">
          <div className="timeline-items">
            {data.map((item: any, index: any) => {
              return (
                <div className="timeline-item">
                  {windowSize.innerWidth > 767 && (
                    <div className="timeline-dot">
                      <p
                        className={`quarters ${
                          item.events.length > 0 ? "" : "blur-text"
                        } `}
                      >
                        {item.quarter}
                      </p>
                    </div>
                  )}
                  {item.events.length > 0 ? (
                    <div className="timeline-content">
                      {windowSize.innerWidth < 767 && <h3>{item.quarter}</h3>}
                      {item.events.map((val: any, key: any) => {
                        return <li className="events-list">{val}</li>;
                      })}
                    </div>
                  ) : (
                    windowSize.innerWidth < 767 && (
                      <div className="timeline-content">
                        <h3 className="text-blur-soon">
                          {"To be revealed soon"}
                        </h3>
                      </div>
                    )
                  )}
                </div>
              );
            })}
          </div>
        </section>
        <div className="timeline-bg-image-left" />
        <div className="timeline-bg-image-right" />
      </div>
      <div className={"timeline_show_more_button"}>
        <Button
          onClick={() => {
            setheight(height === "showMore" ? "showLess" : "showMore");
          }}
          variant={""}
        >
          {height === "showMore" ? "Show less" : "Show more"}
        </Button>
      </div>
    </>
  );
};

export default Timeline;
